import {
  properties,
  time,
  Entity,
  Scheduler,
  coreEngine,
} from "@dinahmoe/dmafjs-core";

class PropertyTransformBatch extends Entity {
  namespace = "control:property:transform:batch";

  init(node) {
    // TODO will require refactoring to support duýnamic values in transforms, please see scaler
    node.pending = new Scheduler(this, this.onComplete.bind(this, node));
    node.pendingStops = new Scheduler(
      this,
      this.doStopTransforms.bind(this, node)
    );
  }

  execute(node, config, event) {
    // change in v20, untested
    node.props = config;
    this.log("setTransforms", event.name);
    node.pending.clear();
    this.setTransforms(node, event.time);
  }

  onComplete(node, onCompleteTime) {
    const eventName = `${node.uid}:complete`;
    this.dispatch(eventName, onCompleteTime);

    if (node.props.loop === true) {
      this.log("looping transform batch", node.uid);
      this.setTransforms(node, onCompleteTime);
    } else {
      coreEngine.destroy(node.uid);
    }
  }

  setTransforms(node, eventTime) {
    let batchEndTime = 0;

    const items = node.props.transforms || [];
    if (!items.length) {
      this.warn(node, "No transform property items provided");
    }

    items.forEach((item) => {
      let delay = item["timing.delay"] || 0;
      let startTime = eventTime + delay;

      if (startTime < time.current) {
        startTime = time.current;
      }

      const propertyUid = item["target.property"];
      const dotIndex = propertyUid.indexOf(".");
      const nodeUid = propertyUid.slice(0, dotIndex);
      const propertyKey = propertyUid.slice(dotIndex + 1);

      const duration = item["timing.duration"];

      coreEngine.update({
        uid: nodeUid,
        key: "transform",
        value: { transforms: [{
          property: propertyKey,
          valueStart: item["target.valueStart"],
          valueEnd: item["target.valueEnd"],
          duration,
          delay,
          easing: item["timing.easing"],
          curve: item["timing.curve"],
        }] },
      });

      if (startTime + duration > batchEndTime) {
        batchEndTime = startTime + duration;
      }
    });

    node.pending.schedule(batchEndTime, batchEndTime);
    this.log("scheduled an onComplete at", batchEndTime);
  }

  stopTransforms(node, event) {
    this.log("stopTransforms");
    node.pendingStops.schedule(event.time);
  }

  doStopTransforms(node) {
    properties.clearTransformPropertyBatch(node.uid);

    this.log("doStopTransforms");
    node.pending.clear();
    coreEngine.destroy(node.uid);
  }
}

const propertyTransformBatch = new PropertyTransformBatch();
export { propertyTransformBatch, PropertyTransformBatch };
